import { useAtomValue } from 'jotai';
import React from 'react';

import Stack from '@mui/material/Stack';
import Box from '@mui/system/Box';

import { navbarHeightAtom } from '../utils/AtomConfig';
import { Refiners } from './Refiners';
import { SearchBox } from './SearchBox';
import { SearchResult } from './SearchResult';
import { Sites } from './Sites';

export function Documents() {
  const navbarHeight = useAtomValue(navbarHeightAtom);
  return (
    <Stack>
      <Sites componentLocation='content' />
      <Stack
        direction='column'
        sx={{
          position: 'fixed',
          top: navbarHeight,
          bottom: 0,
          padding: 2,
          backgroundColor: '#ECECF7',
          width: 367,
          color: '#003591',
          left: 240,
          overflowY: 'auto',
          overflowX: 'hidden',
          display: {
            xs: 'none',
            lg: 'flex',
          },
        }}
      >
        <Refiners componentLocation='content' />
      </Stack>
      <Box
        sx={{
          flexGrow: 1,
          marginLeft: {
            sm: '0',
            lg: '607px',
          },
          padding: 2,
        }}
      >
        <SearchBox />
        <SearchResult />
      </Box>
    </Stack>
  );
}
